module.exports = __webpack_public_path__ + "static/media/radar.73c2f9e9.svg";